"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SvgIcon_1 = require("./SvgIcon");
const { root, fontSizeMedium, fontSizeLarge, fontSizeSmall, colorError, colorDisabled, colorPrimary } = SvgIcon_1.svgIconClasses;
const MuiSvgIconOverrides = {
    MuiSvgIcon: {
        styleOverrides: {
            root: ({ theme }) => ({
                [`&.${root}.${colorError}`]: {
                    color: theme.palette.red[500],
                },
                [`&.${root}.${colorPrimary}`]: {
                    color: theme.palette.blue[500],
                },
                [`&.${root}.${colorDisabled}`]: {
                    color: theme.palette.gray[400],
                },
                [`&.${root}.${fontSizeMedium}`]: {
                    fontSize: '24px',
                },
                [`&.${root}.${fontSizeLarge}`]: {
                    fontSize: '32px',
                },
                [`&.${root}.${fontSizeSmall}`]: {
                    fontSize: '16px',
                },
            }),
        },
    },
};
exports.default = MuiSvgIconOverrides;
//# sourceMappingURL=MuiSvgIconOverrides.js.map